import { Container } from '@mui/material';
import { Outlet } from 'react-router-dom';
import BreadCrumb from '../../../../components/breadcrumb/BreadCrumbNavigation';
import { Header } from './components';
import { NavigationTab } from '..';
import { ProjectProvider, useProject } from './context';
import Loading from '../../../../layouts/loading';

const ProjectHeaderContent = () => {
  const { isLoading } = useProject();

  if (isLoading) return <Loading />;
  return (
    <Container sx={{ height: '100%' }}>
      <Header />
      <NavigationTab />
      <Outlet />
    </Container>
  );
};

const ProjectHeader = () => (
  <ProjectProvider>
    <ProjectHeaderContent />
  </ProjectProvider>
);

export default ProjectHeader;
